import { useCallback } from 'react';

import { components, HttpClientResponse } from '@work4all/data';
import { httpClient } from '@work4all/data/lib/http-client/classes/HttpClient';

import { SERVICE_ACCESS_API_BASE_URL } from '../../mask-overlays/mask-overlay/views/ticket/components/service-access-controller/hooks/use-service-access-api';

export const usePerformLogin = () => {
  const performServiceAccessLogin = useCallback(
    async (props: {
      queryServiceAccessApiUrl: string;
      queryServiceAccessId: string;
      queryServiceAccessCode: string;
      handleLoginResult: (
        res: HttpClientResponse<components['schemas']['AuthResultV2']>
      ) => void;
    }) => {
      const {
        queryServiceAccessApiUrl,
        queryServiceAccessId,
        queryServiceAccessCode,
        handleLoginResult,
      } = props;

      if (
        !queryServiceAccessApiUrl ||
        !queryServiceAccessId ||
        !queryServiceAccessCode
      ) {
        return;
      }

      try {
        const res = await httpClient.get({
          url: `${SERVICE_ACCESS_API_BASE_URL}/Internal/Request/${queryServiceAccessId}/login?code=${queryServiceAccessCode}`,
        });
        if (res.status === 200) {
          handleLoginResult({
            ...res,
            data: {
              ...JSON.parse(res.data),
              baseUrl: queryServiceAccessApiUrl,
            },
          });
        }
      } catch (error) {
        console.error('Service Access Login Error:', error);
        return;
      }
    },
    []
  );

  return {
    performServiceAccessLogin,
  };
};
